import {Member} from "../../src/interfaces/interfaces";

const clenkyDruzstvaNadeji : Member[] = [
    { name: 'Frydrychová Eliška' },
    { name: 'Mikešová Alexandra' },
    { name: 'Vejrostová Laura' },
]

export default clenkyDruzstvaNadeji
